import React, { Component } from 'react';
import { Text, ViewBox, Whitespace } from './../common';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
import { Grid, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import { CallContext } from 'twilio/lib/rest/api/v2010/account/call';
import CustomPagination from '../../components/SearchListing/CustomPagination/CustomPagination';
import Select from './../../components_new/common/FormComponents/SelectMinimal';

import ViewMessage from '../../components/ViewMessage/ViewMessage';
import InputHeader from '../../components_new/common/FormComponents/InputHeader';
import InputStyle from '../../components_new/common/FormComponents/InputStyle';
import { buildAvatarPath } from './../../helpers/photoutils';
import StatusTag from '../common/StatusTag';

import { styleStrings } from './../../helpers/styles-core';

import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Modal from '../Modal';
import { ReservationTimes } from '../reservation/ReservationTimes';
import ApproveReservation from './ApproveReservation';
import { Query } from 'react-apollo';
import { getAvailabilityQ } from './chatQl';
import buildReservationDays from '../../helpers/resevationTimesHelper';
import { getp } from '../../helpers/getProp';

const defaultMessageFilter = {
  value: 'all',
  label: 'All Messages',
};

const messageFilters = [
  defaultMessageFilter,
  {
    value: 'listings',
    label: 'Listings',
  },
  {
    value: 'rentals',
    label: 'Rentals',
  },
];

const filterToQueryMap = {
  all: 'both',
  listings: 'host',
  rentals: 'guest',
};

@observer
export default class ChatScreen extends Component {
  @observable modalOpen = false;

  constructor() {
    super();
    this.state = {
      selectedThread: null,
      selectedFilter: defaultMessageFilter,
      currentPage: 1,
    };
  }

  buildMessageJSX = (threads, threadCount) => {
    const { selectedThread } = this.state;

    if (selectedThread) {
      return (
        <div className="mt-l">
          {threads.map(thread => {
            const { createdAt } = thread;
            const cal = moment(createdAt).calendar();
            const day = cal.split(' ')[0];
            const dateStr =
              day === 'Today' || day === 'Yesterday'
                ? day === 'Today'
                  ? moment(createdAt).format('h:mm a')
                  : day
                : moment(createdAt).format('MMMM D');
            return this.buildSmallJSX(thread, dateStr);
          })}
        </div>
      );
    } else {
      return (
        <div className="g g-tc-7-grow-4 g-g-l pr-l pl-l mt-l f-align-center pointer">
          {threads.map(thread => {
            const { createdAt } = thread;
            const cal = moment(createdAt).calendar();
            const day = cal.split(' ')[0];
            const dateStr =
              day === 'Today' || day === 'Yesterday'
                ? day === 'Today'
                  ? moment(createdAt).format('h:mm a')
                  : day
                : moment(createdAt).format('MMMM D');
            return this.buildLargeJSX(thread, dateStr);
          })}
        </div>
      );
    }
  };

  buildSmallJSX = (thread, dateStr, threadCount) => {
    const {
      listId,
      hostId,
      guestId,
      displayName,
      picture,
      content,
      id,
      isRead,
      type,
      sentBy,
      hasUnread,
    } = thread;
    const { selectedThread } = this.state;
    const { userId } = this.props;
    return (
      <Flex
        key={id || listId + hostId + guestId}
        justifyContent="space-between"
        py="24px"
        flexWrap="wrap"
        onClick={() => this.readThread(thread)}
        className="hover-list-hover pl-l pr-l"
        style={{
          backgroundColor:
            selectedThread && id === selectedThread.id ? colors.offWhite : null,
          borderBottom:
            threadCount === 0 ? null : 'solid 0.5px ' + colors.coolGrayLight,
          marginRight: '-22px',
          marginLeft: '-22px',
        }}
      >
        <Flex alignItems="center" style={{ position: 'relative' }}>
          {hasUnread ? <ReadStatus>.</ReadStatus> : null}
          <AvatarImage
            src={buildAvatarPath(picture)}
            style={{ minWidth: '48px' }}
          />
          <Flex flexWrap="wrap" justifyContent="space-between" mx={1}>
            <Flex
              alignItems="center"
              width="100%"
              justifyContent="space-between"
            >
              <Text large bold inline pl={2}>
                {displayName}
              </Text>
              <Text inline gray2 large>
                {dateStr}
              </Text>
            </Flex>
            <Text pl={2} noclip large>
              {sentBy === userId ? 'You: ' : null}
              {content && content.length > 35
                ? content.substr(0, 30) + '...'
                : content
                ? content
                : 'Status change: ' + type}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    );
  };

  buildLargeJSX = (thread, dateStr) => {
    const {
      listId,
      hostId,
      guestId,
      displayName,
      picture,
      content,
      createdAt,
      id,
      saved,
      isRead,
      type,
      startDate,
      endDate,
      price,
      sentBy,
    } = thread;
    const startD = moment(startDate);
    const endD = moment(endDate);
    const { selectedThread } = this.state;
    const { userId } = this.props;
    const isHost = userId === hostId;
    return (
      <React.Fragment>
        <div className="" onClick={() => this.readThread(thread)}>
          {!isRead && sentBy !== userId ? <ReadStatus /> : null}
        </div>
        <div onClick={() => this.readThread(thread)}>
          <AvatarImage
            src={buildAvatarPath(picture)}
            style={{ minWidth: '48px' }}
          />
        </div>
        <div className="g g-tc-a-1" onClick={() => this.readThread(thread)}>
          <Text clickable large bold inline lineSpacing="16px">
            {displayName}
          </Text>
          <Text clickable inline large>
            {dateStr}
          </Text>
        </div>
        <div
          onClick={() => this.readThread(thread)}
          style={{
            maxHeight: '48px',
          }}
        >
          <Text clickable noclip large style={{ maxHeight: '48px' }}>
            {sentBy === userId ? 'You: ' : null}
            {content ? content : 'Status change: ' + type}
          </Text>
        </div>
        <div
          className="g g-tc-fr-1 f-ji-end"
          onClick={() => this.readThread(thread)}
        >
          <StatusTag status={type} isHost={isHost} />
          <div className="g g-tc-a-3 g-g-m">
            {(startDate && endDate && (
              <div className="g g-tc-a-3  g-g-sxx">
                <Text clickable large>
                  {startD.format('MMM D')}
                </Text>
                <Text clickable large>
                  -
                </Text>
                <Text clickable large>
                  {endD.format(startD.month() !== endD.month() ? 'MMM D' : 'D')}
                </Text>
              </div>
            )) || <div> Inquiry </div>}
            <Text clickable large>
              -
            </Text>
            <Text clickable emphasis large>
              ${price}
            </Text>
          </div>
        </div>
        <div>
          <i className="fal fa-star fa-lg cool-gray" title="coming soon" />
        </div>
        <div>
          <i className="fal fa-times cool-gray" title="coming soon" />
        </div>
      </React.Fragment>
    );
  };

  buildThreadItem = (thread, userId) => {
    const otherPersonsProfile =
      userId === thread.hostId ? thread.guestProfile : thread.hostProfile;
    const lastThread =
      thread.threadItems.length > 0
        ? thread.threadItems[thread.threadItems.length - 1]
        : {};

    const unreads = thread.threadItems.filter(
      x => x.sentBy !== userId && !x.isRead,
    );
    const hasUnread = unreads.length > 0;
    const reservation = thread.reservation;
    return {
      listId: thread.listId,
      listData: thread.listData,
      id: thread.id,
      hostId: thread.hostId,
      guestId: thread.guestId,
      displayName: otherPersonsProfile.displayName,
      picture: otherPersonsProfile.picture,
      content: lastThread.content,
      createdAt: lastThread.createdAt,
      sentBy: lastThread.sentBy,
      startDate: getp(reservation, 'checkIn'),
      endDate: getp(reservation, 'checkOut'),
      type: getp(reservation, 'reservationState'),
      saved: thread.saved,
      isRead: lastThread.isRead,
      price: thread.listData.basePrice,
      guestProfile: thread.guestProfile,
      hostProfile: thread.hostProfile,
      threadItems: thread.threadItems,
      guestUserData: thread.guestUserData,
      hostUserData: thread.hostUserData,
      reservation: thread.reservation,
      reservationId: thread.reservation && thread.reservation.id,
      hasUnread,
    };
  };

  buildInbox = (threads, userId) => {
    console.log('BI 0');
    const { focusedThread } = this.props;
    const threads2 = threads.GetAllThreads.threadsData.map(ti =>
      this.buildThreadItem(ti, userId),
    );
    let ft;
    console.log('BI 1');
    if (focusedThread && focusedThread.id) {
      console.log('BI 2');
      ft = this.buildThreadItem(focusedThread, userId);
    }
    console.log('BI 3');
    if (ft) {
      console.log('BI 4');
      const match = threads2.filter(x => x.id === ft.id);
      if (match.length === 0) {
        console.log('BI 5');
        threads2.unshift(ft);
      }
    }

    const newArr = threads2.sort((a, b) => {
      const key1 = a.createdAt;
      const key2 = b.createdAt;

      if (key1 > key2) {
        return -1;
      } else if (key1 === key2) {
        return 0;
      }
      return 1;
    });
    return newArr;
  };

  componentDidUpdate() {
    if (!this.state.selectedThread) {
      const { focusedThread } = this.props;
      if (focusedThread && focusedThread.id) {
        this.setState({
          selectedThread: focusedThread,
        });
      }
      return;
    }

    const {
      threads,
      threads: { loading },
    } = this.props;

    if (!loading) {
      const threadData = threads.GetAllThreads.threadsData;
      const match = threadData.filter(
        t => t.id === this.state.selectedThread.id,
      );
      if (
        match &&
        match.length > 0 &&
        match[0].threadItems.length >
          this.state.selectedThread.threadItems.length
      ) {
        this.setState({
          selectedThread: match[0],
        });
      }
    }
  }

  readThread = thread => {
    const { readMessage } = this.props;
    readMessage(thread.id, null);
    this.setState({ selectedThread: thread });
  };

  back = () => {
    this.setState({
      selectedThread: null,
    });
  };

  handlePagination = cp => {
    const currentPage = cp ? cp : 1;
    const { threads } = this.props;
    const { keywords, selectedFilter } = this.state;
    const threadType = filterToQueryMap[selectedFilter.value];

    this.setState({ currentPage });
    threads.fetchMore({
      variables: { currentPage, keywords, threadType },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, fetchMoreResult);
      },
    });
  };

  search = e => {
    if (e.keyCode === 13) {
      setTimeout(this.handlePagination());
    }
  };

  keywordsChange = e => {
    this.setState({
      keywords: e.target.value,
    });
  };

  selectNewFilter = selectedFilter => {
    this.setState({ selectedFilter }, () => this.handlePagination());
  };

  startApproval = () => {
    this.modalOpen = true;
  };

  render() {
    const {
      threads,
      threads: { loading },
      userId,
      approve,
    } = this.props;

    const { currentPage } = this.state;

    if (!loading && threads.error && threads.error.message) {
      console.log('Error fetching threads', threads.error);
      return (
        <div>
          We're sorry we cannot load this screen at this time. Please contact
          support.
        </div>
      );
    }

    if (!loading && !threads.GetAllThreads) {
      console.log('No threads found');
      return <div>No messages found</div>;
    }

    const hostProfile = loading
      ? {}
      : threads.GetAllThreads.threadsData.hostProfile;
    const guestProfile = loading
      ? {}
      : threads.GetAllThreads.threadsData.guestProfile;

    const { selectedThread } = this.state;

    // if (selectedThread) {
    //   console.log('selectedThread', JSON.stringify(selectedThread));
    // }

    const threadCount = threads.loading ? 0 : threads.GetAllThreads.count;
    return (
      <Grid>
        <Row>
          <Col md={selectedThread ? 4 : 12}>
            <ViewBox
              style={{
                minWidth: '380px',
                width: selectedThread ? '380px' : '100%',
                marginRight: '50px',
                minHeight: selectedThread ? '75vh' : 'auto',
                paddingTop: '0px',
                paddingRight: '32px',
                paddingLeft: '8px'
              }}
              loading={loading}
              justifyContent={!threads ? 'center' : null}
              alignItems={!threads ? 'center' : null}
            >
              <Flex
                justifyContent={selectedThread ? 'space-between' : 'flex-end'}
                alignItems="center"
                className="pl-sx"
              >
                {selectedThread && (
                  <BackButton onClick={this.back}>
                    <i className="fal fa-chevron-circle-left" />
                    <Text xlarge inline ml={4} clickable>
                      Go Back
                    </Text>
                  </BackButton>
                )}
                <Select
                  defaultValue={defaultMessageFilter}
                  onChange={this.selectNewFilter}
                  options={messageFilters}
                  style={{
                    marginRight: '-8px', //Offset padding to right aling the arrow
                  }}
                />
              </Flex>
              <SearchContainer>
                <MessageSearch
                  placeholder="Search your messages"
                  onChange={this.keywordsChange}
                  onKeyUp={this.search}
                />
                <i
                  className="fa fa-search"
                  style={{
                    color: colors.primaryDark,
                    position: 'absolute',
                    left: '14px',
                    top: '9px',
                    fontSize: '18px',
                    fontWeight: 400,
                  }}
                />
              </SearchContainer>
              {threads.loading ? (
                <Flex height="100%">
                  <i className="fa fa-spinner" />
                </Flex>
              ) : !threads.GetAllThreads.count ? (
                <Flex height="100%">
                  <Text>No messages found.</Text>
                </Flex>
              ) : (
                this.buildMessageJSX(
                  this.buildInbox(threads, userId).slice(0, 6),
                  threadCount,
                )
              )}
              {threadCount > 6 && (
                <CustomPagination
                  label="messages"
                  total={threadCount}
                  current={currentPage}
                  defaultCurrent={1}
                  defaultPageSize={5}
                  handleChange={this.handlePagination}
                />
              )}
            </ViewBox>
          </Col>

          {!loading && selectedThread && (
            <Flex>
              <ViewMessage
                thread={selectedThread}
                userId={userId}
                startApproval={this.startApproval}
              />
            </Flex>
          )}

          <Modal isOpen={this.modalOpen} maxWidth={800}>
            <Query
              query={getAvailabilityQ}
              variables={{ id: selectedThread && selectedThread.reservationId }}
            >
              {({ loading, error, data }) => {
                console.log(
                  'GET GET AVAIL',
                  loading,
                  JSON.stringify(data),
                  error,
                );
                return (
                  (error && <Text>Whoops</Text>) || (
                    <ApproveReservation
                      loading={loading}
                      close={() => (this.modalOpen = false)}
                      data={
                        !loading &&
                        getp(
                          data,
                          'ReservationAvailabilityRange.blockedDates',
                          [],
                        )
                      }
                      messages={
                        !loading &&
                        JSON.parse(
                          getp(
                            data,
                            'ReservationAvailabilityRange.messages',
                            '{}',
                          ),
                        )
                      }
                      approve={params =>
                        approve(
                          params,
                          selectedThread,
                          data.ReservationAvailabilityRange.reservation.id,
                        )
                      }
                      reservation={
                        !loading &&
                        data.ReservationAvailabilityRange.reservation
                      }
                    />
                  )
                );
              }}
            </Query>
          </Modal>
        </Row>
      </Grid>
    );
  }
}

const AvatarImage = styled.img`
  width: 48px;
  height: 48px;
  border: solid 1.5px ${colors.primaryDark};
  border-radius: 50%;
  object-fit: cover;
`;

const BackButton = styled.div`
  font-size: 18px;
  cursor: pointer;
`;

const SearchContainer = styled.div`
  position: relative;
`;

const MessageSearch = styled.input`
  width: 100%;
  height: 36px;
  border-radius: 19px;
  background-color: #f2f2f2;
  border: none;
  padding: 4px 15px 4px 40px;
  font-size: 16px;
`;

const ReadStatus = styled.div`
  background-color: #a81616;
  width: 8px;
  height: 8px;
  border-radius: 100px;
`;

/*  Selected Thread


{
  "listId": 8,
  "listData": {
    "city": "Lehi",
    "state": "UT",
    "country": "US",
    "title": "Rubix Cube",
    "coverPhotoName": "77eec23fcec06725e4596c4adb997276.jpeg",
    "__typename": "ShowListing"
  },
  "id": 43,
  "hostId": "ff1c8050-1ff4-11e9-98e0-713860d3fa2b",
  "guestId": "4d63be80-2573-11e9-98bb-2f2bd39e1319",
  "displayName": "Jeremy Robertson",
  "picture": "64c2e0e4d5da9466d2a49f2c71c8b942.png",
  "content": "adsfasdfasdfad",
  "createdAt": "Mon Feb 18 2019 12:47:12 GMT-0700 (Mountain Standard Time)",
  "sentBy": "4d63be80-2573-11e9-98bb-2f2bd39e1319",
  "startDate": "Wed Mar 13 2019 05:00:00 GMT-0600 (Mountain Daylight Time)",
  "endDate": "Thu Mar 14 2019 05:00:00 GMT-0600 (Mountain Daylight Time)",
  "type": "pending",
  "isRead": true,
  "price": 22,
  "guestProfile": {
    "profileId": 7,
    "displayName": "Jeremy Robertson",
    "firstName": "Jeremy",
    "picture": "64c2e0e4d5da9466d2a49f2c71c8b942.png",
    "createdAt": "Thu Jan 31 2019 09:14:36 GMT-0700 (Mountain Standard Time)",
    "__typename": "userProfile"
  },
  "hostProfile": {
    "profileId": 1,
    "displayName": "Jeremy Robertson",
    "firstName": "Jeremy",
    "picture": "b3b10dccb82274ca4da2e4a2e5899d9f.png",
    "createdAt": "Thu Jan 24 2019 09:27:52 GMT-0700 (Mountain Standard Time)",
    "__typename": "userProfile"
  },
  "threadItems": [
    {
      "id": 255,
      "threadId": 43,
      "content": "adsfasdfasdfad",
      "sentBy": "4d63be80-2573-11e9-98bb-2f2bd39e1319",
      "isRead": true,
      "type": "pending",
      "startDate": "Wed Mar 13 2019 05:00:00 GMT-0600 (Mountain Daylight Time)",
      "endDate": "Thu Mar 14 2019 05:00:00 GMT-0600 (Mountain Daylight Time)",
      "createdAt": "Mon Feb 18 2019 12:47:12 GMT-0700 (Mountain Standard Time)",
      "__typename": "ThreadItems"
    }
  ],
  "guestUserData": {
    "email": "jeremy@yoodlize.com",
    "__typename": "User"
  },
  "hostUserData": {
    "email": "admin+test@yoodlize.com",
    "__typename": "User"
  }
}

*/



// WEBPACK FOOTER //
// ./src/components_new/Inbox/ChatScreen.js